import type { Ref } from "react";

// Traced line art for the homepage scroll story, copied verbatim from the
// prototype's hybrid.html (`svg.facade-svg`). Every path uses pathLength="1" so
// useTransitionStory can draw them on with 0→1 stroke-dash values.

const PERSISTENT_BUILDING_PATHS: readonly string[] = [
  "M518 936V151H956V936M518 161H956M528 178H946M534 189H938M518 635H956M518 647H956M518 663H956",
  "M576 278h81v11h-81Z",
  "M584 291h65v117h-65Z",
  "M591 299h51v101h-51Z",
  "M591 353.01h51",
  "M576 408h81v10h-81Z",
  "M710 280h80v11h-80Z",
  "M718 293h64v114h-64Z",
  "M725 301h50v98h-50Z",
  "M725 353.42h50",
  "M710 407h80v10h-80Z",
  "M842 280h81v11h-81Z",
  "M850 293h65v115h-65Z",
  "M857 301h51v99h-51Z",
  "M857 353.95h51",
  "M842 408h81v10h-81Z",
  "M577 462h80v11h-80Z",
  "M585 475h64v129h-64Z",
  "M592 483h50v113h-50Z",
  "M592 543.37h50",
  "M577 604h80v10h-80Z",
  "M710 462h80v11h-80Z",
  "M718 475h64v128h-64Z",
  "M725 483h50v112h-50Z",
  "M725 542.84h50",
  "M710 603h80v10h-80Z",
  "M841 462h80v11h-80Z",
  "M849 475h64v128h-64Z",
  "M856 483h50v112h-50Z",
  "M856 542.84h50",
  "M841 603h80v10h-80Z",
  "M532 678h286v211h-286Z",
  "M829 678h95v240h-95Z",
  "M541 722h103v154h-103Z",
  "M653 722h156v154h-156Z",
  "M842 740h69v161h-69Z",
  "M530 716H925M646 678V890M818 678V920M518 927H950M554 192H669V247H554ZM689 192H810V247H689ZM830 192H945V247H830Z",
];

const NEIGHBORS_PATHS: readonly string[] = [
  "M65 936V90H518V936M65 100H518M75 117H508M81 128H500M65 646H518M65 658H518M65 674H518",
  "M106 227h87v11h-87Z",
  "M114 240h71v122h-71Z",
  "M121 248h57v106h-57Z",
  "M121 304.65999999999997h57",
  "M106 362h87v10h-87Z",
  "M255 227h83v11h-83Z",
  "M263 240h67v122h-67Z",
  "M270 248h53v106h-53Z",
  "M270 304.65999999999997h53",
  "M255 362h83v10h-83Z",
  "M394 225h84v11h-84Z",
  "M402 238h68v124h-68Z",
  "M409 246h54v108h-54Z",
  "M409 303.72h54",
  "M394 362h84v10h-84Z",
  "M103 436h88v11h-88Z",
  "M111 449h72v150h-72Z",
  "M118 457h58v134h-58Z",
  "M118 528.5h58",
  "M103 599h88v10h-88Z",
  "M252 436h86v11h-86Z",
  "M260 449h70v150h-70Z",
  "M267 457h56v134h-56Z",
  "M267 528.5h56",
  "M252 599h86v10h-86Z",
  "M392 435h85v11h-85Z",
  "M400 448h69v152h-69Z",
  "M407 456h55v136h-55Z",
  "M407 528.56h55",
  "M392 600h85v10h-85Z",
  "M51 698h448v226h-448Z",
  "M78 740h99v166h-99Z",
  "M186 740h204v137h-204Z",
  "M400 740h77v166h-77Z",
  "M50 697H493L456 738H13ZM104 149H212V175H104ZM244 148H350V175H244ZM386 148H491V175H386Z",
  "M961 936V130H1379V936M961 140H1379M971 157H1369M977 168H1361M961 624H1379M961 636H1379M961 652H1379",
  "M989 266h87v11h-87Z",
  "M997 279h71v119h-71Z",
  "M1004 287h57v103h-57Z",
  "M1004 342.07h57",
  "M989 398h87v10h-87Z",
  "M1129 266h80v11h-80Z",
  "M1137 279h64v119h-64Z",
  "M1144 287h50v103h-50Z",
  "M1144 342.07h50",
  "M1129 398h80v10h-80Z",
  "M1264 265h84v11h-84Z",
  "M1272 278h68v120h-68Z",
  "M1279 286h54v104h-54Z",
  "M1279 341.6h54",
  "M1264 398h84v10h-84Z",
  "M989 450h85v11h-85Z",
  "M997 463h69v136h-69Z",
  "M1004 471h55v120h-55Z",
  "M1004 535.08h55",
  "M989 599h85v10h-85Z",
  "M1129 450h81v11h-81Z",
  "M1137 463h65v136h-65Z",
  "M1144 471h51v120h-51Z",
  "M1144 535.08h51",
  "M1129 599h81v10h-81Z",
  "M1263 450h85v11h-85Z",
  "M1271 463h69v136h-69Z",
  "M1278 471h55v120h-55Z",
  "M1278 535.08h55",
  "M1263 599h85v10h-85Z",
  "M976 681h387v240h-387Z",
  "M986 741h263v139h-263Z",
  "M1259 741h84v172h-84Z",
  "M976 683H1358L1396 734H978ZM994 193H1077V215H994ZM1106 193H1230V215H1106ZM1257 193H1334V215H1257Z",
  "M1385 936V95H1863V936M1385 105H1863M1395 122H1853M1401 133H1845M1385 626H1863M1385 638H1863M1385 654H1863",
  "M1425 228h85v11h-85Z",
  "M1433 241h69v134h-69Z",
  "M1440 249h55v118h-55Z",
  "M1440 312.02h55",
  "M1425 375h85v10h-85Z",
  "M1569 228h82v11h-82Z",
  "M1577 241h66v134h-66Z",
  "M1584 249h52v118h-52Z",
  "M1584 312.02h52",
  "M1569 375h82v10h-82Z",
  "M1714 229h85v11h-85Z",
  "M1722 242h69v134h-69Z",
  "M1729 250h55v118h-55Z",
  "M1729 313.02h55",
  "M1714 376h85v10h-85Z",
  "M1427 435h83v11h-83Z",
  "M1435 448h67v150h-67Z",
  "M1442 456h53v134h-53Z",
  "M1442 527.5h53",
  "M1427 598h83v10h-83Z",
  "M1569 435h82v11h-82Z",
  "M1577 448h66v150h-66Z",
  "M1584 456h52v134h-52Z",
  "M1584 527.5h52",
  "M1569 598h82v10h-82Z",
  "M1714 435h85v11h-85Z",
  "M1722 448h69v150h-69Z",
  "M1729 456h55v134h-55Z",
  "M1729 527.5h55",
  "M1714 598h85v10h-85Z",
  "M1411 674h427v248h-427Z",
  "M1422 681h137v189h-137Z",
  "M1591 681h131v189h-131Z",
  "M1737 681h91v238h-91Z",
  "M1411 673H1556L1587 762H1427ZM1413 152H1534V180H1413ZM1573 152H1680V180H1573ZM1712 152H1832V180H1712Z",
];

const BUSINESS_PATHS: readonly string[] = [
  "M575 727v24m-15 13 15-13 15 13Zm0 8v10m-18-12-7 9m43-9 7 9",
  "M707 727v24m-15 13 15-13 15 13Zm0 8v10m-18-12-7 9m43-9 7 9",
  "M778 727v24m-15 13 15-13 15 13Zm0 8v10m-18-12-7 9m43-9 7 9",
  "M558 847h226M575 847v22M769 847v22M602 841v-25h29v25M610 816v-9h15v9M689 836h39v11M573 896h82m-72 0v30m62-30v30M573 906h82M723 895h72m-62 0v31m52-31v31",
];

const COMMUNITY_PATHS: readonly string[] = [
  "M42 951H1868M180 961h95m-81 0v39m65-39v39M293 948h90m-78 0v44m65-44v44M1060 961h100m-85 0v39m70-39v39M1160 956h90m-78 0v42m65-42v42M1460 948h90m-75 0v45m60-45v45",
  "M440 909h40v38h-40Z",
  "M460 909v-49m0 24-22-16m22 25 22-20m-22 0-12-19m12 5 13-14",
  "M945 909h40v38h-40Z",
  "M965 909v-49m0 24-22-16m22 25 22-20m-22 0-12-19m12 5 13-14",
  "M1340 909h40v38h-40Z",
  "M1360 909v-49m0 24-22-16m22 25 22-20m-22 0-12-19m12 5 13-14",
  "M1810 909h40v38h-40Z",
  "M1830 909v-49m0 24-22-16m22 25 22-20m-22 0-12-19m12 5 13-14",
];

export type FacadeIllustrationRefs = {
  svg: Ref<SVGSVGElement>;
  photo: Ref<SVGImageElement>;
  ink: Ref<SVGGElement>;
  persistent: Ref<SVGGElement>;
  neighbors: Ref<SVGGElement>;
  business: Ref<SVGGElement>;
  shared: Ref<SVGGElement>;
  community: Ref<SVGGElement>;
};

function Paths({ paths }: { paths: readonly string[] }) {
  return paths.map((d) => <path key={d} pathLength={1} d={d} />);
}

/**
 * The photographed storefront (`photoUrl`) with its traced line art on top.
 * All per-frame styling (viewBox zoom, clip, stroke draw-on, group fades) is
 * applied imperatively by useTransitionStory; the classes here only carry the
 * p=0 state so SSR and the first client paint match.
 *
 * `preserveAspectRatio="xMidYMid slice"` makes the pre-JS paint fill the
 * viewport like the story's initial crop; the hook switches it to `meet` once
 * it takes over the viewBox.
 */
export function FacadeIllustration({
  refs,
  photoUrl,
  className,
}: {
  refs: FacadeIllustrationRefs;
  photoUrl: string;
  className?: string;
}) {
  return (
    <svg
      ref={refs.svg}
      className={className}
      viewBox="0 0 1920 1280"
      preserveAspectRatio="xMidYMid slice"
      role="img"
      aria-labelledby="facade-title"
    >
      <title id="facade-title">
        The photographed brick storefront becomes a shared neighborhood
      </title>
      <image ref={refs.photo} className="facade-photo" href={photoUrl} width="1920" height="1280" />
      <g ref={refs.ink} className="facade-ink">
        <g ref={refs.persistent} className="persistent-building">
          <Paths paths={PERSISTENT_BUILDING_PATHS} />
        </g>
        <g ref={refs.neighbors} className="facade-neighbors">
          <Paths paths={NEIGHBORS_PATHS} />
        </g>
        <g ref={refs.business} className="facade-business">
          <Paths paths={BUSINESS_PATHS} />
          <text x="675" y="703" className="facade-sign">
            LOCAL GOODS
          </text>
        </g>
        <g ref={refs.shared} className="facade-shared" />
        <g ref={refs.community} className="facade-community">
          <Paths paths={COMMUNITY_PATHS} />
        </g>
      </g>
    </svg>
  );
}
